export default {
  allInvoices: [],
  invoice: {},
}
